export const isDevMode = window.location.hostname === 'localhost'
export const TOKEN_KEY = 'PAVUKAT' as const
export const UINFO_KEY = 'PAVUKUINFO' as const
export const MODULE_REDIRECT_PAGE_MAP = {
    1: '',
    2: '/downloads',
    3: '/integrations',
} as const
export const MESSENGER_TYPE_MAP = {
    2: 'Signal',
    3: 'Telegram',
    4: 'WhatsApp',
} as const

export const OBJECT_TYPES = [
    {
        id: 0,
        name: 'Article',
        key: 'article',
        icon: 'news',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 1,
        name: 'Post',
        key: 'post',
        icon: 'wysiwyg',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 2,
        name: 'Comment',
        key: 'comment',
        icon: 'chat',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 3,
        name: 'Share',
        key: 'share',
        icon: 'reply',
        iconType: 'icons',
        iconVendor: 'google',
    },
    {
        id: 4,
        name: 'Video',
        key: 'video',
        icon: 'smart_display',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 5,
        name: 'Image',
        key: 'image',
        icon: 'imagesmode',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 6,
        name: 'Classified',
        key: 'classified',
        icon: 'layers',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 7,
        name: 'Event',
        key: 'event',
        icon: 'event_available',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 8,
        name: 'Domain',
        key: 'domain',
        icon: 'captive_portal',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 9,
        name: 'Channel',
        key: 'channel',
        icon: 'reset_tv',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 10,
        name: 'Page',
        key: 'page',
        icon: 'web',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 11,
        name: 'Profile',
        key: 'profile',
        icon: 'badge',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 12,
        name: 'Group',
        key: 'group',
        icon: 'dataset',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 13,
        name: 'Chat',
        key: 'chat',
        icon: 'forum',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 14,
        name: 'Ad',
        key: 'ad',
        icon: 'featured_video',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 15,
        name: 'Story',
        key: 'story',
        icon: 'newspaper',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 16,
        name: 'Mobile App',
        key: 'mobile_app',
        icon: 'extension',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 17,
        name: 'Product',
        key: 'product',
        icon: 'stacks',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 18,
        name: 'Vacancy',
        key: 'vacancy',
        icon: 'receipt_long',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 20,
        name: 'Tender',
        key: 'tender',
        icon: 'contract_edit',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 21,
        name: 'Audio',
        key: 'audio',
        icon: 'music_note',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 22,
        name: 'Document',
        key: 'document',
        icon: 'description',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 23,
        name: 'Location',
        key: 'location',
        icon: 'location_on',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 24,
        name: 'Contact',
        key: 'contact',
        icon: 'perm_contact_calendar',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 25,
        name: 'Poll',
        key: 'poll',
        icon: 'new_releases',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 26,
        name: 'Action',
        key: 'action',
        icon: 'ads_click',
        iconType: 'symbols',
        iconVendor: 'google',
    },
    {
        id: 27,
        name: 'Letter',
        key: 'letter',
        icon: 'mail',
        iconType: 'symbols',
        iconVendor: 'google',
    },
]
